// import { getCurrentEmailsFromLocalStorage, setCurrentEmailsInLocalStorage } from "helpers/sf_utils"
import _ from "lodash"
import { buildCampaignAnalysisCacheKey } from "helpers/sf_utils"
import {
  GET_LEADS,
  GET_LEADS_SUCCESS,
  GET_LEADS_ERROR,
  GET_LEAD_BY_ID,
  GET_LEAD_BY_ID_SUCCESS,
  GET_LEAD_BY_ID_ERROR,
  GET_LEAD_BY_QUOTE_CALL_ID,
  GET_LEAD_BY_QUOTE_CALL_ID_SUCCESS,
  GET_LEAD_BY_QUOTE_CALL_ID_ERROR,
  UPDATE_LEAD_DETAILS,
  UPDATE_LEAD_DETAILS_SUCCESS,
  UPDATE_LEAD_DETAILS_ERROR,
  ADD_LEAD_VEHICLE,
  ADD_LEAD_VEHICLE_SUCCESS,
  UPDATE_LEAD_VEHICLE,
  ADD_LEAD_VEHICLE_ERROR,
  UPDATE_LEAD_VEHICLE_SUCCESS,
  UPDATE_LEAD_VEHICLE_ERROR,
  DELETE_LEAD_VEHICLE,
  DELETE_LEAD_VEHICLE_SUCCESS,
  ADD_LEAD_BUSINESS_ENTITY,
  ADD_LEAD_BUSINESS_ENTITY_SUCCESS,
  ADD_LEAD_BUSINESS_ENTITY_ERROR,
  UPDATE_LEAD_BUSINESS_ENTITY,
  UPDATE_LEAD_BUSINESS_ENTITY_SUCCESS,
  UPDATE_LEAD_BUSINESS_ENTITY_ERROR,
  DELETE_LEAD_BUSINESS_ENTITY_SUCCESS,
  DELETE_LEAD_BUSINESS_ENTITY_ERROR,
  DELETE_LEAD_BUSINESS_ENTITY,
  ADD_LEAD_VIOLATION_SUCCESS,
  UPDATE_LEAD_VIOLATION_SUCCESS,
  UPDATE_LEAD_VIOLATION_ERROR,
  DELETE_LEAD_VIOLATION_SUCCESS,
  DELETE_LEAD_VIOLATION_ERROR,
  DELETE_LEAD_VIOLATION,
  ADD_LEAD_VIOLATION_ERROR,
  UPDATE_LEAD_VIOLATION,
  ADD_LEAD_VIOLATION,
  ADD_LEAD_REFUND,
  DELETE_LEAD_REFUND,
  DELETE_LEAD_REFUND_SUCCESS,
  UPDATE_LEAD_REFUND,
  UPDATE_LEAD_REFUND_SUCCESS,
  ADD_LEAD_REFUND_ERROR,
  ADD_LEAD_REFUND_SUCCESS,
  UPDATE_LEAD_REFUND_ERROR,
  ADD_LEAD_APPLICANT_SUCCESS,
  ADD_LEAD_APPLICANT,
  ADD_LEAD_APPLICANT_ERROR,
  UPDATE_LEAD_APPLICANT,
  UPDATE_LEAD_APPLICANT_SUCCESS,
  UPDATE_LEAD_APPLICANT_ERROR,
  DELETE_LEAD_APPLICANT,
  DELETE_LEAD_APPLICANT_SUCCESS,
  DELETE_LEAD_APPLICANT_ERROR,
  ADD_LEAD_HOME,
  ADD_LEAD_HOME_SUCCESS,
  ADD_LEAD_HOME_ERROR,
  UPDATE_LEAD_HOME,
  UPDATE_LEAD_HOME_SUCCESS,
  UPDATE_LEAD_HOME_ERROR,
  DELETE_LEAD_HOME,
  DELETE_LEAD_HOME_SUCCESS,
  DELETE_LEAD_HOME_ERROR,
  GET_LEAD_REFUND_REASONS_ERROR,
  GET_LEAD_REFUND_REASONS_SUCCESS,
  GET_LEAD_REFUND_REASONS,
  UPDATE_LEAD,
  UPDATE_LEAD_SUCCESS,
  UPDATE_LEAD_ERROR,
  GET_LEAD_DETAILS_EXPORT,
  GET_LEAD_DETAILS_EXPORT_SUCCESS,
  GET_LEAD_DETAILS_EXPORT_ERROR,
} from "./actionTypes"

const INIT_STATE = {
  leads: [],
  parsed_leads: [],
  error: null,
  loading: false,
  loading_lead_detail_export: false,
  get_leads_loading: false,
  last_page_fetched: 0,
  last_fetched_at: null,
  total_number_of_pages: 0,
  last_start_date: null,
  last_end_date: null,
  lead_refund_reasons: [],
  has_next_page: false,
  has_lookahead_pages: false,
  page_size: null,
  active_cache_key: null,
  page_cache: {},
}
const Leads = (state = INIT_STATE, action) => {
  switch (action.type) {
    case GET_LEADS: {

      const queryParams = action.payload?.queryParams || {}
      const { start_date, end_date, page_number } = queryParams
      const shouldReplaceResults = Boolean(action.payload?.replaceResults)
      const useCache = Boolean(action.payload?.useCache)
      const cacheKey = useCache ? buildCampaignAnalysisCacheKey(queryParams) : null
      const cachedPage = useCache ? state.page_cache?.[cacheKey]?.[page_number] : null
      let date_range_changed = false
      if (!(start_date == state.last_start_date && end_date == state.last_end_date)) {
        date_range_changed = true
      }

      const shouldResetRows = shouldReplaceResults || page_number === 1 || page_number !== (state.last_page_fetched + 1)
      return {
        ...state,
        error: null,
        leads: cachedPage?.rows || (shouldResetRows ? [] : state.leads),
        get_leads_loading: !cachedPage,
        last_page_fetched: cachedPage?.page_number || (date_range_changed ? 0 : state.last_page_fetched),
        total_number_of_pages: cachedPage?.total_number_of_pages || state.total_number_of_pages,
        has_next_page: typeof cachedPage?.has_next_page === 'boolean' ? cachedPage.has_next_page : state.has_next_page,
        has_lookahead_pages: typeof cachedPage?.has_lookahead_pages === 'boolean' ? cachedPage.has_lookahead_pages : state.has_lookahead_pages,
        page_size: cachedPage?.page_size || state.page_size,
        active_cache_key: useCache ? cacheKey : null,

      }
    }

    case GET_LEADS_SUCCESS: {
      const payloadData = action.payload.data
      const rows = Array.isArray(payloadData) ? payloadData : []
      const additional = action.payload.additional_data || {}
      const useCacheMeta = Boolean(action.meta?.useCache)
      const metaQueryParams = action.meta?.queryParams || {}
      const cacheKey = useCacheMeta ? buildCampaignAnalysisCacheKey(metaQueryParams) : null
      const shouldReplaceResults = Boolean(action.meta?.replaceResults)
      const pageNum = parseInt(additional.page_number, 10)
      const totalPages = parseInt(additional.total_number_of_pages, 10)
      const safePage = Number.isFinite(pageNum) && pageNum > 0 ? pageNum : 1
      const safeTotal = Number.isFinite(totalPages) && totalPages >= 0 ? totalPages : 0
      const hasNextPage = typeof additional.has_next_page === 'boolean' ? additional.has_next_page : false
      const hasLookAheadPages = typeof additional.has_lookahead_pages === 'boolean' ? additional.has_lookahead_pages : false
      const pageSize = Number(additional.page_size) || null
      const pageSnapshot = {
        rows,
        page_number: safePage,
        total_number_of_pages: safeTotal,
        has_next_page: hasNextPage,
        has_lookahead_pages: hasLookAheadPages,
        page_size: pageSize,
      }
      let uniqueLeads = []
      if (shouldReplaceResults) {
        uniqueLeads = rows
      } else {
        const all_leads = [...state.leads, ...rows]
        all_leads.forEach(function (item) {
          const i = uniqueLeads.findIndex(x => x.id == item.id);
          if (i <= -1) {
            uniqueLeads.push(item);
          }
        });
      }

      return {
        ...state,
        error: null,
        leads: uniqueLeads,
        get_leads_loading: false,
        last_fetched_at: new Date(),
        last_page_fetched: safePage,
        last_start_date: additional.start_date,
        last_end_date: additional.end_date,
        total_number_of_pages: safeTotal,
        has_next_page: hasNextPage,
        has_lookahead_pages: hasLookAheadPages,
        page_size: pageSize,
        active_cache_key: useCacheMeta ? cacheKey : state.active_cache_key,
        page_cache: useCacheMeta ? {
          ...state.page_cache,
          [cacheKey]: {
            ...(state.page_cache?.[cacheKey] || {}),
            [safePage]: pageSnapshot,
          },
        } : state.page_cache,

      }
    }

    case GET_LEADS_ERROR:
      return {
        ...state,
        error: action.payload,
        get_leads_loading: false,
        has_next_page: false,
        has_lookahead_pages: false,
      }

    case UPDATE_LEAD:
      return {
        ...state,
        error: null,
        loading: true,
      }

    case UPDATE_LEAD_SUCCESS:
      return {
        ...state,
        error: null,
        leads: state.leads.map(lead => lead.id == action.payload.id ? action.payload : lead),
        loading: false,
      }

    case UPDATE_LEAD_ERROR:
      return {
        ...state,
        error: action.payload,
        loading: false,
      }

    case GET_LEAD_BY_ID:
      return {
        ...state,
        error: null,
        loading: true,
      }
    case GET_LEAD_BY_ID_SUCCESS:
      const lead_id = action.payload.id
      const lead_index = state.leads.findIndex(lead => lead.id == lead_id)
      let leads = _.cloneDeep(state.leads)
      if (lead_index == -1) {
        leads.push(action.payload)
      } else {
        leads[lead_index] = { ...leads[lead_index], ...action.payload }
      }
      return {
        ...state,
        leads: leads,
        error: null,
        leads: action.payload,
        loading: false
      }
    case GET_LEAD_BY_ID_ERROR:
      return {
        ...state,
        error: action.payload,
        loading: false
      }

    case GET_LEAD_BY_QUOTE_CALL_ID:
      return {
        ...state,
        error: null,
        loading: true,
      }

    case GET_LEAD_BY_QUOTE_CALL_ID_SUCCESS: {
      const responseLead = action.payload[0]
      const quote_call_id = responseLead.quote_call.id
      const parsed_lead_index = state.parsed_leads.findIndex(lead => lead && lead.quote_call.id == quote_call_id)
      let parsed_leads = _.cloneDeep(state.parsed_leads)
      if (parsed_lead_index == -1) {
        parsed_leads.push(responseLead)
      } else {
        parsed_leads[parsed_lead_index] = { ...parsed_leads[parsed_lead_index], ...responseLead }
      }
      return {
        ...state,
        parsed_leads: parsed_leads,
        error: null,
        loading: false,
      }
    }

    case GET_LEAD_BY_QUOTE_CALL_ID_ERROR:
      return {
        ...state,
        error: action.payload,
        loading: false,
      }

    case UPDATE_LEAD_DETAILS:
      return {
        ...state,
        error: null,
        loading: true,
      }
    case UPDATE_LEAD_DETAILS_SUCCESS:
      {
        const leadToUpdate = state.leads.find(lead => lead.id === action.payload.lead_id);

        leadToUpdate.lead_detail = { ...leadToUpdate.lead_details, ...action.payload };
        return {
          ...state,
          error: null,
          leads: state.leads.map(lead => lead.id === leadToUpdate.id ? leadToUpdate : lead),
          loading: false,
        }
      }
    case UPDATE_LEAD_DETAILS_ERROR:
      return {
        ...state,
        error: action.payload,
        loading: false,
      }

    case ADD_LEAD_VEHICLE:
      return {
        ...state,
        error: null,
        loading: true
      }

    case ADD_LEAD_VEHICLE_SUCCESS:
      {
        const leadToUpdate = state.leads.find(lead => lead.id === action.payload.lead_id);
        leadToUpdate.lead_vehicles.push(action.payload);
        return {
          ...state,
          error: null,
          leads: state.leads.map(lead => lead.id === action.payload.lead_id ? leadToUpdate : lead),
          loading: false,
        }
      }
    case ADD_LEAD_VEHICLE_ERROR:
      return {
        ...state,
        error: action.payload,
        loading: false,
      }

    case UPDATE_LEAD_VEHICLE:
      return {
        ...state,
        error: null,
        loading: true
      }
    case UPDATE_LEAD_VEHICLE_SUCCESS:
      {
        const leadToUpdate = state.leads.find(lead => lead.lead_vehicles.some(vehicle => vehicle.id === action.payload.id));
        const vehicleIndex = leadToUpdate.lead_vehicles.findIndex(vehicle => vehicle.id === action.payload.id);
        leadToUpdate.lead_vehicles[vehicleIndex] = action.payload;
        return {
          ...state,
          error: null,
          leads: state.leads.map(lead => lead.id === leadToUpdate.id ? leadToUpdate : lead),
          loading: false,
        }

      }
    case UPDATE_LEAD_VEHICLE_ERROR:
      return {
        ...state,
        error: action.payload,
        loading: false,
      }

    case DELETE_LEAD_VEHICLE:
      return {
        ...state,
        error: null,
      }

    case DELETE_LEAD_VEHICLE_SUCCESS:
      {
        const leadToUpdate = state.leads.find(lead => lead.lead_vehicles.some(vehicle => vehicle.id === action.payload.id));
        const vehicleIndex = leadToUpdate.lead_vehicles.findIndex(vehicle => vehicle.id === action.payload.id);
        leadToUpdate.lead_vehicles.splice(vehicleIndex, 1);
        return {
          ...state,
          error: null,
          leads: state.leads.map(lead => lead.id === leadToUpdate.id ? leadToUpdate : lead),
          loading: false,
        }
      }

    case ADD_LEAD_BUSINESS_ENTITY:
      return {
        ...state,
        error: null,
        loading: true
      }

    case ADD_LEAD_BUSINESS_ENTITY_SUCCESS:
      {
        const leadToUpdate = state.leads.find(lead => lead.id === action.payload.lead_id);
        leadToUpdate.lead_business_entities.push(action.payload);
        return {
          ...state,
          error: null,
          leads: state.leads.map(lead => lead.id === leadToUpdate.id ? leadToUpdate : lead),
          loading: false,
        }
      }

    case ADD_LEAD_BUSINESS_ENTITY_ERROR:
      return {
        ...state,
        error: action.payload,
        loading: false,
      }

    case UPDATE_LEAD_BUSINESS_ENTITY:
      return {
        ...state,
        error: null,
        loading: true
      }

    case UPDATE_LEAD_BUSINESS_ENTITY_SUCCESS:
      {
        const leadToUpdate = state.leads.find(lead => lead.lead_business_entities.some(business_entity => business_entity.id === action.payload.id));
        const business_entityIndex = leadToUpdate.lead_business_entities.findIndex(business_entity => business_entity.id === action.payload.id);
        leadToUpdate.lead_business_entities[business_entityIndex] = action.payload;
        return {
          ...state,
          error: null,
          leads: state.leads.map(lead => lead.id === leadToUpdate.id ? leadToUpdate : lead),
          loading: false,
        }
      }

    case UPDATE_LEAD_BUSINESS_ENTITY_ERROR:
      return {
        ...state,
        error: action.payload,
        loading: false,
      }

    case DELETE_LEAD_BUSINESS_ENTITY:
      return {
        ...state,
        error: null,
      }

    case DELETE_LEAD_BUSINESS_ENTITY_SUCCESS:
      {
        const leadToUpdate = state.leads.find(lead => lead.lead_business_entities.some(business_entity => business_entity.id === action.payload.id));
        const business_entityIndex = leadToUpdate.lead_business_entities.findIndex(business_entity => business_entity.id === action.payload.id);
        leadToUpdate.lead_business_entities.splice(business_entityIndex, 1);
        return {
          ...state,
          error: null,
          leads: state.leads.map(lead => lead.id === leadToUpdate.id ? leadToUpdate : lead),
          loading: false,
        }
      }

    case DELETE_LEAD_BUSINESS_ENTITY_ERROR:
      return {
        ...state,
        error: action.payload,
        loading: false,
      }

    case ADD_LEAD_VIOLATION:
      return {
        ...state,
        error: null,
        loading: true
      }

    case ADD_LEAD_VIOLATION_SUCCESS:
      {
        const leadToUpdate = state.leads.find(lead => lead.id === action.payload.lead_id);
        leadToUpdate.lead_violations.push(action.payload);
        return {
          ...state,
          error: null,
          leads: state.leads.map(lead => lead.id === leadToUpdate.id ? leadToUpdate : lead),
          loading: false,
        }
      }

    case ADD_LEAD_VIOLATION_ERROR:
      return {
        ...state,
        error: action.payload,
        loading: false,
      }

    case UPDATE_LEAD_VIOLATION:
      return {
        ...state,
        error: null,
        loading: true,
      }

    case UPDATE_LEAD_VIOLATION_SUCCESS:
      {
        const leadToUpdate = state.leads.find(lead => lead.lead_violations.some(violation => violation.id === action.payload.id));
        const violationIndex = leadToUpdate.lead_violations.findIndex(violation => violation.id === action.payload.id);
        leadToUpdate.lead_violations[violationIndex] = action.payload;
        return {
          ...state,
          error: null,
          leads: state.leads.map(lead => lead.id === leadToUpdate.id ? leadToUpdate : lead),
          loading: false,
        }
      }

    case UPDATE_LEAD_VIOLATION_ERROR:
      return {
        ...state,
        error: action.payload,
        loading: false,
      }

    case DELETE_LEAD_VIOLATION:
      return {
        ...state,
        error: null,
        loading: true
      }

    case DELETE_LEAD_VIOLATION_SUCCESS:
      {
        const leadToUpdate = state.leads.find(lead => lead.lead_violations.some(violation => violation.id === action.payload.id));
        const violationIndex = leadToUpdate.lead_violations.findIndex(violation => violation.id === action.payload.id);
        leadToUpdate.lead_violations.splice(violationIndex, 1);
        return {
          ...state,
          error: null,
          leads: state.leads.map(lead => lead.id === leadToUpdate.id ? leadToUpdate : lead),
          loading: false,
        }

      }

    case DELETE_LEAD_VIOLATION_ERROR:
      return {
        ...state,
        error: action.payload,
        loading: false,
      }


    //Lead Home
    case ADD_LEAD_HOME:
      return {
        ...state,
        error: null,
      }

    case ADD_LEAD_HOME_SUCCESS:
      {
        const leadToUpdate = state.leads.find(lead => lead.id === action.payload.lead_id);
        leadToUpdate.lead_homes.push(action.payload);
        return {
          ...state,
          error: null,
          leads: state.leads.map(lead => lead.id === leadToUpdate.id ? leadToUpdate : lead),
          loading: false,
        }
      }

    case ADD_LEAD_HOME_ERROR:
      return {
        ...state,
        error: action.payload,
        loading: false,
      }

    case UPDATE_LEAD_HOME:
      return {
        ...state,
        error: null,
        loading: true
      }

    case UPDATE_LEAD_HOME_SUCCESS:
      {
        const leadToUpdate = state.leads.find(lead => lead.lead_homes.some(home => home.id === action.payload.id));
        const homeIndex = leadToUpdate.lead_homes.findIndex(home => home.id === action.payload.id);
        leadToUpdate.lead_homes[homeIndex] = action.payload;
        return {
          ...state,
          error: null,
          leads: state.leads.map(lead => lead.id === leadToUpdate.id ? leadToUpdate : lead),
          loading: false,
        }
      }

    case UPDATE_LEAD_HOME_ERROR:
      return {
        ...state,
        error: action.payload,
        loading: false,
      }

    case DELETE_LEAD_HOME:
      return {
        ...state,
        loading: true,
        error: null,
      }

    case DELETE_LEAD_HOME_SUCCESS:
      {
        const leadToUpdate = state.leads.find(lead => lead.lead_homes.some(home => home.id === action.payload.id));
        const homeIndex = leadToUpdate.lead_homes.findIndex(home => home.id === action.payload.id);
        leadToUpdate.lead_homes.splice(homeIndex, 1);
        return {
          ...state,
          error: null,
          leads: state.leads.map(lead => lead.id === leadToUpdate.id ? leadToUpdate : lead),
          loading: false,
        }

      }

    case DELETE_LEAD_HOME_ERROR:
      return {
        ...state,
        error: action.payload,
        loading: false,
      }

    //Lear Refund

    case ADD_LEAD_REFUND:
      return {
        ...state,
        error: null,
      }

    case ADD_LEAD_REFUND_SUCCESS:
      {
        const leadToUpdate = state.leads.find(lead => lead.id === action?.payload?.lead_id);
        leadToUpdate.lead_refund = action.payload;
        return {
          ...state,
          error: null,
          leads: state.leads.map(lead => lead.id === leadToUpdate.id ? leadToUpdate : lead),
          loading: false,
        }
      }

    case ADD_LEAD_REFUND_ERROR:
      return {
        ...state,
        error: action.payload,
        loading: false,
      }

    case UPDATE_LEAD_REFUND:
      return {
        ...state,
        error: null,
        loading: true
      }

    case UPDATE_LEAD_REFUND_SUCCESS:
      {
        const leadToUpdate = state.leads.find(lead => lead.lead_refunds.some(refund => refund.id === action.payload.id));
        leadToUpdate.lead_refund = action.payload;
        return {
          ...state,
          error: null,
          leads: state.leads.map(lead => lead.id === leadToUpdate.id ? leadToUpdate : lead),
          loading: false,
        }

      }

    case UPDATE_LEAD_REFUND_ERROR:
      return {
        ...state,
        error: action.payload,
        loading: false,
      }

    case DELETE_LEAD_REFUND:
      return {
        ...state,
        error: null,
        loading: true
      }

    case DELETE_LEAD_REFUND_SUCCESS:
      {
        const leadToUpdate = state.leads.find(lead => lead.id === action?.payload?.lead_id);
        leadToUpdate.lead_refund = null
        return {
          ...state,
          error: null,
          leads: state.leads.map(lead => lead.id === leadToUpdate.id ? leadToUpdate : lead),
          loading: false,
        }
      }

    case ADD_LEAD_APPLICANT:
      return {
        ...state,
        error: null,
        loading: true
      }

    case ADD_LEAD_APPLICANT_SUCCESS:
      {
        const leadToUpdate = state.leads.find(lead => lead.id === action.payload.lead_id);
        leadToUpdate.lead_applicants.push(action.payload);
        return {
          ...state,
          error: null,
          leads: state.leads.map(lead => lead.id === action.payload.lead_id ? leadToUpdate : lead),
          loading: false,
        }
      }

    case ADD_LEAD_APPLICANT_ERROR:
      return {
        ...state,
        error: action.payload,
        loading: false,
      }

    case UPDATE_LEAD_APPLICANT:
      return {
        ...state,
        error: null,
        loading: true
      }

    case UPDATE_LEAD_APPLICANT_SUCCESS:
      {
        const leadToUpdate = state.leads.find(lead => lead.lead_applicants.some(applicant => applicant.id === action.payload.id));
        const applicantIndex = leadToUpdate.lead_applicants.findIndex(applicant => applicant.id === action.payload.id);
        leadToUpdate.lead_applicants[applicantIndex] = action.payload;
        return {
          ...state,
          error: null,
          leads: state.leads.map(lead => lead.id === leadToUpdate.id ? leadToUpdate : lead),
          loading: false,
        }
      }

    case UPDATE_LEAD_APPLICANT_ERROR:
      return {
        ...state,
        error: action.payload,
        loading: false,
      }

    case DELETE_LEAD_APPLICANT:
      return {
        ...state,
        error: null,
      }

    case DELETE_LEAD_APPLICANT_SUCCESS:

      {
        const leadToUpdate = state.leads.find(lead => lead.lead_applicants.some(applicant => applicant.id === action.payload.id));
        const applicantIndex = leadToUpdate.lead_applicants.findIndex(applicant => applicant.id === action.payload.id);
        leadToUpdate.lead_applicants.splice(applicantIndex, 1);
        return {
          ...state,
          error: null,
          leads: state.leads.map(lead => lead.id === leadToUpdate.id ? leadToUpdate : lead),
          loading: false,
        }
      }

    case DELETE_LEAD_APPLICANT_ERROR:
      return {
        ...state,
        error: action.payload,
        loading: false,
      }

    case GET_LEAD_REFUND_REASONS:
      return {
        ...state,
        error: null,
        loading: true
      }

    case GET_LEAD_REFUND_REASONS_SUCCESS:
      const new_state = {
        ...state,
        error: null,
        lead_refund_reasons: action.payload,
        loading: false,
      }
      return new_state;

    case GET_LEAD_REFUND_REASONS_ERROR:
      return {
        ...state,
        error: action.payload,
        loading: false,
      }

    case GET_LEAD_DETAILS_EXPORT:
      return {
        ...state,
        error: null,
        loading_lead_detail_export: true
      }

    case GET_LEAD_DETAILS_EXPORT_SUCCESS:
      return {
        ...state,
        error: null,
        loading_lead_detail_export: false
      }

    case GET_LEAD_DETAILS_EXPORT_ERROR:
      return {
        ...state,
        error: action.payload,
        loading_lead_detail_export: false
      }
    default:
      return state
  }
}

export default Leads
